//src/services/adminUserActivity.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminUsersActivity = () => {
  return adminApiRequest("/admin/analytics/users-activity");
};

export const deleteAdminUserActivity = (id) =>
  adminApiRequest(`/admin/analytics/users-activity/${id}`, {
    method: "DELETE",
  });